import PropTypes from "prop-types";

import { GdprStorage } from "../../uidispatcherapi/GdprStorage";

import React from "react";
import { IntlRootMixin } from "../../IntlRootMixin";
import createReactClass from "create-react-class";

import NaviRibbon from "./NaviRibbon";
import { connect } from "../../utils/storeConnect";
import SessionStore from "../../stores/SessionStore";
import { withReactAdapter } from "../../module-federation/withReactAdapter";

export const HeaderEmployee = createReactClass({
    propTypes: {
        isEmployee: PropTypes.bool,
        isMcrmCountry: PropTypes.bool
    },

    mixins: [IntlRootMixin],

    /**
     * check whether we want to show menu items for pages in beta status
     */
    shouldShowBetaItems() {
        const setting = GdprStorage.localStorage.read("menuItems");
        return setting === "beta";
    },

    render() {
        const show = this.props.isEmployee;
        if (show) {
            window.document.body.classList.add("with-employee-ribbonnavbar-fixed-top");
        } else {
            window.document.body.classList.remove("with-employee-ribbonnavbar-fixed-top");
            return null;
        }

        return <NaviRibbon showBeta={this.shouldShowBetaItems()} showOrderFulfillment={!this.props.isMcrmCountry} />;
    }
});

export default withReactAdapter(
    connect(
        {
            stores: [
                [
                    SessionStore,
                    (store: typeof SessionStore) => ({
                        isEmployee: store.getState().isEmployee,
                        isMcrmCountry: store.getState().isMcrmCountry
                    })
                ]
            ]
        },
        HeaderEmployee
    )
);
